if (!window.customLocalizationInitialized) {
  window.customLocalizationInitialized = true;

  document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.custom-localization-wrapper');

    wrappers.forEach(wrapper => {
      const trigger = wrapper.querySelector('.custom-localization-trigger');
      const dropdown = wrapper.querySelector('.custom-localization-dropdown');
      const form = wrapper.querySelector('[data-localization-form]');

      // Le comportement dropdown (toggle + fermeture) n'existe qu'en mode dropdown.
      // Le panneau langue du menu mobile n'a ni trigger ni bouton de fermeture :
      // on garde donc ces écouteurs, mais la logique de formulaire (plus bas) s'exécute
      // dans les deux modes.
      if (trigger && dropdown) {
      // Toggle dropdown on trigger click
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        const isOpen = wrapper.hasAttribute('open');

        // Close all dropdowns
        wrappers.forEach(w => w.removeAttribute('open'));

        if (!isOpen) {
          wrapper.setAttribute('open', '');
        }
      });

      const closeBtn = wrapper.querySelector('.custom-localization-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          wrapper.removeAttribute('open');
        });
      }

      // Close when clicking outside, or on the modal backdrop (desktop = event.target is the wrapper itself)
      document.addEventListener('click', function(event) {
        if (!wrapper.contains(event.target) || event.target === wrapper) {
          wrapper.removeAttribute('open');
        }
      });

      // Close the modal on Escape (desktop popup)
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && wrapper.hasAttribute('open')) {
          wrapper.removeAttribute('open');
        }
      });
      } // fin garde trigger/dropdown

      // Expose l'etat d'ouverture au declencheur du header (aria-expanded)
      if (trigger) {
        new MutationObserver(function() {
          trigger.setAttribute('aria-expanded', wrapper.hasAttribute('open') ? 'true' : 'false');
        }).observe(wrapper, { attributes: true, attributeFilter: ['open'] });
      }

      // Menu-based localization system (replaces Orbe)
      if (form) {
        // Get localization data from JSON script
        const dataScript = wrapper.querySelector('[data-localization-data]');
        let localizationData = null;

        if (dataScript) {
          try {
            localizationData = JSON.parse(dataScript.textContent);
          } catch (e) {
            console.error('Error parsing localization data:', e);
          }
        }

        if (localizationData) {
          const countryContainer = form.querySelector('[data-country-options]');
          const languageContainer = form.querySelector('[data-language-options]');

          // Tracks whether updateLanguages successfully ran for the selected country.
          // Used to detect stale language values (from the source site) on cross-domain navigation.
          let languageExplicitlySelected = false;

          // Helper function to update languages based on selected country
          const updateLanguages = (countryLabel) => {
            if (!languageContainer || !localizationData) return;

            // Find the country in data
            const country = localizationData.countries.find(
              c => c.label.toUpperCase() === countryLabel.toUpperCase()
            );

            if (!country || !country.languages) return;

            // Clear current languages
            languageContainer.innerHTML = '';

            // Add language options
            country.languages.forEach((lang, index) => {
              const label = document.createElement('label');
              label.className = 'custom-localization-option';
              label.innerHTML = `
                <input
                  type="radio"
                  name="language"
                  value="${lang.url}"
                  data-language-label="${lang.label}"
                  ${index === 0 ? 'checked' : ''}>
                ${lang.label}
              `;
              languageContainer.appendChild(label);
            });

          };

          // Listen to country changes — reset flag, language is not explicitly chosen
          if (countryContainer) {
            countryContainer.addEventListener('change', function(e) {
              if (e.target.name === 'country') {
                const selectedCountryLabel = e.target.getAttribute('data-country-label');
                if (selectedCountryLabel) {
                  languageExplicitlySelected = false;
                  updateLanguages(selectedCountryLabel);
                }
              }
            });
          }

          // Listen to language changes — user explicitly picked a language
          if (languageContainer) {
            languageContainer.addEventListener('change', function(e) {
              if (e.target.name === 'language') {
                languageExplicitlySelected = true;
              }
            });
          }

          // Handle form submission
          form.addEventListener('submit', function(e) {
            e.preventDefault();

            const selectedCountryInput = form.querySelector('input[name="country"]:checked');
            const selectedLanguageInput = form.querySelector('input[name="language"]:checked');

            if (!selectedCountryInput || !selectedLanguageInput) {
              console.error('Country or language not selected');
              return;
            }

            const countryUrl = selectedCountryInput.value;
            const languageUrl = selectedLanguageInput.value;

            // Get current page path
            let currentPath = window.location.pathname;

            // Ensure path starts with /
            if (!currentPath.startsWith('/')) {
              currentPath = '/' + currentPath;
            }

            // Remove locale prefix from current path (e.g., /fr/produit → /produit)
            currentPath = currentPath.replace(/^\/(fr|de|en|es|it|nl|pt|ar|ja|zh|ko|ru|sv|pl|da|fi|nb)(\/|$)/i, '/');

            // Determine the final URL
            let finalUrl;

            // If language URL is absolute
            if (languageUrl.startsWith('http')) {
              try {
                const langUrlObj = new URL(languageUrl);
                let langPath = langUrlObj.pathname;

                // Remove trailing slash from language path to avoid double slashes
                if (langPath.endsWith('/') && langPath.length > 1) {
                  langPath = langPath.slice(0, -1);
                }

                finalUrl = langUrlObj.origin + langPath + currentPath;
              } catch (err) {
                console.error('Error constructing URL from absolute language URL:', err);
                finalUrl = languageUrl;
              }
            }
            // If language URL is relative and country URL is absolute
            else if (languageUrl.startsWith('/') && countryUrl.startsWith('http')) {
              try {
                const countryUrlObj = new URL(countryUrl);
                let langPath = languageUrl;

                // When navigating to a different domain, only keep the locale path
                // if the user explicitly selected a language for the target country.
                // Otherwise the value is stale from the source site.
                if (countryUrlObj.hostname !== window.location.hostname && !languageExplicitlySelected) {
                  langPath = '/';
                }

                // If language path is just '/', use empty string to avoid double slashes
                if (langPath === '/') {
                  langPath = '';
                }

                // Combine country domain + language path + current page path
                finalUrl = countryUrlObj.origin + langPath + currentPath;
              } catch (err) {
                console.error('Error constructing URL:', err);
                finalUrl = countryUrl;
              }
            }
            // Fallback
            else {
              finalUrl = languageUrl + currentPath;
            }

            // Redirect to the selected country/language with current page path
            window.location.href = finalUrl;

            // Close dropdown
            wrappers.forEach(w => w.removeAttribute('open'));
          });
        } else {
          // If no menu data, fall back to standard Shopify localization form behavior
          // The form will submit normally using Shopify's localization system
          console.log('Using standard Shopify localization form');
        }
      }
    });

    // ─────────────────────────────────────────────────────────────────────────
    // Mutualisation : tout element [data-localization-modal-trigger] (sélecteurs
    // langue / marché du footer, etc.) ouvre LA MEME modale que le header, au lieu
    // de dupliquer un dropdown par sélecteur.
    //
    // La modale partagee est l'instance NON "panel" (le layout "panel" est le
    // panneau statique intégré au drill-down du menu mobile, il ne s'ouvre pas).
    // ─────────────────────────────────────────────────────────────────────────
    const sharedModal = document.querySelector(
      '.custom-localization-wrapper:not(.custom-localization-wrapper--panel)'
    );
    const externalTriggers = document.querySelectorAll('[data-localization-modal-trigger]');

    externalTriggers.forEach(externalTrigger => {
      // Pas de modale partagee dans le DOM (ex. settings.localization_menu vide)
      // → on masque le declencheur plutot que de laisser un bouton inerte.
      if (!sharedModal) {
        externalTrigger.setAttribute('hidden', '');
        return;
      }

      // Ecouteur direct (et non delegue) + stopPropagation : indispensable pour que
      // le listener "clic exterieur" enregistre plus haut ne referme pas la modale
      // dans la foulee, le declencheur etant hors du wrapper.
      externalTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = sharedModal.hasAttribute('open');
        wrappers.forEach(w => w.removeAttribute('open'));

        if (!isOpen) {
          sharedModal.setAttribute('open', '');
        }
      });

      if (sharedModal) {
        new MutationObserver(function() {
          externalTrigger.setAttribute(
            'aria-expanded',
            sharedModal.hasAttribute('open') ? 'true' : 'false'
          );
        }).observe(sharedModal, { attributes: true, attributeFilter: ['open'] });
      }
    });
  });
}